import BulkPhotoDownloaderContainer from "../../container/admin/bulk-photo-downloader";

const BulkPhotoDownloaderView = () => {
    return <BulkPhotoDownloaderContainer />;
};

export default BulkPhotoDownloaderView;
